import css from 'styled-jsx/css'
import { colors, grids } from '../../styles'

const breakpoints = {
  medium: grids.medium.breakpoint,
  wide: grids.wide.breakpoint,
  tablet: grids.medium.breakpoint,
  desktop: grids.superWide.breakpoint,
}

/**
 * font-size: size in px / base font size (normally 16px)
 * line-height: line height in px / font-size in px
 *
 * Ideally we'd use functions for this but styled-jsx doesn't like
 * functions in external files for some reason.
 */

const display1 = css`
.display1 {
  color: ${colors.primaryText};
  font-size: ${24 / 16}rem;
  font-weight: 800;
  line-height: ${28 / 24};
}

@media (min-width: ${breakpoints.tablet}px) {
  .display1 {
    font-size: ${24 / 16}rem;
    line-height: ${40 / 36};
  }
}

@media (min-width: ${breakpoints.desktop}px) {
  .display1 {
    font-size: ${24 / 16}rem;
  }
}
`

const display2 = css`
.display2 {
  color: ${colors.primaryText};
  font-size: ${18 / 16}rem;
  font-weight: 800;
  line-height: ${22 / 18};
}

@media (min-width: ${breakpoints.tablet}px) {
  .display2 {
    font-size: ${28 / 16}rem;
    line-height: ${32 / 28};
  }
}

@media (min-width: ${breakpoints.desktop}px) {
  .display2 {
    font-size: ${32 / 16}rem;
    line-height: ${40 / 32};
  }
}
`

const display3 = css`
.display3 {
  color:  ${colors.tertiaryText};
  font-size: ${20 / 16}rem;
  font-weight: bold;
  line-height: ${24 / 20};
}

@media (min-width: ${breakpoints.tablet}px) {
  .display3 {
    font-size: ${24 / 16}rem;
    line-height: ${24 / 20};
  }
}

@media (min-width: ${breakpoints.desktop}px) {
  .display3 {
    font-size: ${28 / 16}rem;
    line-height: ${32 / 28}
  }
}
`

const display4 = css`
.display4 {
  color: ${colors.black};
  font-size: ${20 / 16}rem;
  font-weight: 800;
  line-height: ${24 / 20};
}

@media (min-width: ${breakpoints.tablet}px) {
  .display4 {
    font-size: ${24 / 16}rem;
    line-height: ${28 / 24};
  }
}
`

const display5 = css`
.display5 {
  color: ${colors.primaryText};
  font-size: ${18 / 16}rem;
  font-weight: 800;
  line-height: ${22 / 18};
}

.display5:hover {
  color: ${colors.textHoverPurple}
}

@media (min-width: ${breakpoints.tablet}px) {
  .display5 {
    font-size: ${20 / 16}rem;
    line-height: ${24 / 20};
  }
}
`

const cardTitle1 = css`
.cardTitle1 {
  color: ${colors.primaryText};
  font-size: ${16 / 16}rem;
  font-weight: bold;
  line-height: ${20 / 16};
}
.cardTitle1.guide-card{
  font-size: 18px;
}

@media (min-width: ${breakpoints.tablet}px) {
  .cardTitle1 {
    font-size: ${16 / 16}rem;
    line-height: ${22 / 16};
  }
  .cardTitle1.guide-card{
    color: var(--white-01-f-6-f-6-f-6, #F6F6F6);
    font-family: "Source Sans Pro";
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
}
`

const cardTitleHidden = css`
.cardTitleHidden {
  color: transparent;
  font-size: 0px;
  line-height: 0px;
}`

const cardTitle2 = css`
.cardTitle2 {
  color: ${colors.darkText};
  font-size: ${14 / 16}rem;
  line-height: ${18 / 14};
}

@media (min-width: ${breakpoints.tablet}px) {
  .cardTitle2 {
    font-size: ${16 / 16}rem;
    line-height: ${20 / 16};
  }
}
`

const lead1 = css`
.lead1 {
  color: ${colors.darkText};
  font-size: ${16 / 16}rem;
  font-weight: bold;
  line-height: ${24 / 16};
}

@media (min-width: ${breakpoints.tablet}px) {
  .lead1 {
    font-size: ${18 / 16}rem;
    line-height: ${26 / 18};
  }
}
`

const lead2 = css`
.lead2 {
  color: ${colors.tertiaryText};
  font-size: ${16 / 16}rem;
  line-height: ${24 / 16}
}

@media (min-width: ${breakpoints.tablet}px) {
  .lead2 {
    font-size: ${18 / 16}rem;
    line-height: ${26 / 18};
  }
}
`

const p1 = css`
.p1 {
  color: ${colors.darkText};
  font-size: ${14 / 16}rem;
  font-weight: bold;
  line-height: ${14 / 14};
}
`

const p2 = css`
.p2 {
  color: ${colors.tertiaryText};
  font-size: ${14 / 16}rem;
  line-height: ${22 / 14};
}
.p2.description {
color: var(--white-01-f-6-f-6-f-6, #F6F6F6);
font-family: "Source Sans Pro";
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: normal;
}
.p2.time-stamp{
  color: var(--white-02-c-4-c-4-c-4, #C4C4C4);
  font-family: "Source Sans Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
@media (max-width: ${breakpoints.tablet}px) {
  .p2 {
    text-overflow: ellipsis;
    overflow: hidden;
    height: 25px;
  }

  .p2.description {
    height: auto;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 2;
  }
  .p2.popup-description{
    line-height: ${22 / 14};
    height: auto;
    overflow: visible;
  }
  .p2.description {
    font-size: 14px;
    }
    .p2.time-stamp{
      height: auto;
      font-size: 14px;
    }
}
`

const cardSubtitle = css`
.cardSubtitle {
  color: ${colors.secondaryText};
  font-size: ${14 / 16}rem;
  line-height: ${18 / 14};
}
`

const label = css`
.label {
  color: ${colors.black};
  font-size: ${14 / 16}rem;
  line-height: ${18 / 14};
  font-weight: bold;
}
`

const cardLabel = css`
.cardLabel {
  color: ${colors.textHoverPurple};
  font-size: ${12 / 16}rem;
  font-weight: bold;
  line-height: ${15 / 12};
}`

const continueWatchingCardLabel = css`
.continueWatchingCardLabel {
  display: flex;
  width: 248px;
  flex-direction: column;
  flex-shrink: 0;
  color: var(--white-01-f-6-f-6-f-6, #F6F6F6);
  text-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 1px 3px 1px rgba(0, 0, 0, 0.15);
  font-family: 'Source Sans Pro';
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}`

const styles = {
  display1,
  display2,
  display3,
  display4,
  display5,
  cardTitle1,
  cardTitle2,
  cardTitleHidden,
  lead1,
  lead2,
  p1,
  p2,
  label,
  cardSubtitle,
  cardLabel,
  continueWatchingCardLabel,
}

export default styles
